import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import DiferenciaisSection from './components/DiferenciaisSection';
import ComoFuncionaSection from './components/ComoFuncionaSection';
import FAQSection from './components/FAQSection';
import ContatoSection from './components/ContatoSection';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <HeroSection />
      <ServicesSection />
      <DiferenciaisSection />
      <ComoFuncionaSection />
      <FAQSection />
      <ContatoSection />
      <Footer />
    </div>
  );
}